import React, { useState, useEffect } from 'react';
import "./footer.css"
import LogoWhite from '../../assets/images/logo-white.svg'
import LogoFooter from '../../assets/images/footer-logo.svg'
import LogoGreen from '../../assets/images/logo-green.jpg'
import Email from '../../assets/icons/footer/email.svg'
import Phone from '../../assets/icons/footer/phone.svg'
import Clock from '../../assets/icons/footer/clock.svg'
import Instagram from '../../assets/icons/footer/instagram.svg'
import Whatsapp from '../../assets/icons/footer/whatsapp.svg'
import Youtub from '../../assets/icons/footer/youtub.svg'
import ArrowTop from '../../assets/icons/footer/arrowTop.svg'
import Samaneh from '../../assets/images/samaneh.svg'
import { getContact, imgBaseUrl } from '../../utils/api'

const Footer = () => {
  const [contactInfo, setContactInfo] = useState([])
  // Fetch categories
  useEffect(() => {
    const fetchContact = async () => {
      try {
        const pay = { pageSize: 0, pageIndex: 0 };
        const res = await getContact(pay);
        const items = res.data.data.items;
        setContactInfo(items.filter(product => product.isActive));
      } catch (error) {
        console.error('Error fetching Contact:', error);
      }
    };
    fetchContact();
  }, []);

  // Helper function to find a contact by title
  const getContactValue = (title) => {
    const contact = contactInfo.find((item) => item.title === title);
    return contact ? contact.value : '';
  };
  const getContactImage = (title) => {

    const contact = contactInfo.find((item) => item.title === title);
    console.log(contact)
    return contact ? contact.logoPath : '';
  };
  const handleScrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // Smooth scroll effect
    });
  };
  return (
    <div className='footer-body'>
      <div className='footer web container mb-3'>
        <div className='top-btn'>
          <div className='left-btn'></div>
          <div className='right-btn'></div>
          <div >
            <img src={ArrowTop} alt="" onClick={handleScrollToTop} style={{ cursor: 'pointer' }} />

          </div>

        </div>
        <div className='d-flex align-items-center justify-content-start mt-2 gap-5'>
          {/* <div className='img-box'> */}
          {/* <img src={LogoWhite} alt="" /> */}
          {/* </div> */}
          <div className='item'>
            <h6 className='font-normal text-xl'><span className='font-bold text-3xl'>طبیعی باش</span>، با لذت بنوشید ...</h6>
            <p className='font-medium text-base	mt-3 mb-0'>
              اگر به دنبال تجربه‌های متنوع و جذاب در دنیای نوشیدنی‌ها هستید، ما برای شما تنوعی از نوشیدنی‌ها و مزه‌ها فراهم کرده‌ایم. از طعم‌های فوق‌العاده قهوه‌های اسپرسو و لته‌؛ گرم و خوشمزه تا طعم‌های ترکیبی از میوه‌ها در نوشابه‌های ما، مطمئناً انتخابی برای هر سلیقه و فصلی پیدا خواهید کرد.
            </p>

          </div>

        </div>
        <div className=' detail d-flex align-items-center mt-4 ' >
          {/* Contact Information */}
          <div className='item  '>
            <h6 className='font-bold text-base'>امور مشتریان</h6>
            {
              getContactValue('email') != '' &&

              <div className='d-flex align-items-center justify-content-between mt-2'>
                <div className='d-flex align-items-center gap-2 flex-1'>
                  <div className='footer-icon'>
                    <img src={imgBaseUrl + getContactImage('email')} alt="" width={16} />
                  </div>
                  <h6 className='font-bold text-xs mb-0'>ایمیل:</h6>
                </div>
                <a href={`mailto:${getContactValue('email')}`} className='text-center  flex-1'>
                  <h6 className='text-[#00A14B] text-xs text-center w-100'>{getContactValue('email')}</h6></a>
              </div>
            }
            {
              getContactValue('telephon') != '' &&

              <div className='d-flex align-items-center justify-content-between mt-2'>
                <div className='d-flex align-items-center gap-2 flex-1'>
                  <div className='footer-icon'>
                    <img src={imgBaseUrl + getContactImage('telephon')} alt="" width={16} />
                  </div>
                  <h6 className='font-bold text-xs mb-0'>شماره تماس:</h6>
                </div>
                <a href={`tel:${getContactValue('telephon')}`}  className='text-center  flex-1'>
                  <h6 className='text-[#00A14B] text-xs text-center w-100'>{getContactValue('telephon')}</h6> </a>
              </div>
            }
            {

              getContactValue('answer') != '' &&

              <div className='d-flex align-items-center justify-content-between mt-2'>
                <div className='d-flex align-items-center gap-2 flex-1'>
                  <div className='footer-icon'>
                    <img src={imgBaseUrl + getContactImage('answer')} alt="" width={16} />
                  </div>
                  <h6 className='font-bold text-xs mb-0 '>زمان پاسخگویی:</h6>
                </div>
                <h6 className='text-[#00A14B] text-xs flex-1 text-center '>{getContactValue('answer')}</h6>
              </div>
            }
          </div>
          {/* Social Media Information */}
          <div className='item contact  mr-2'>
            <h6 className='font-bold text-base'>شبکه های اجتماعی</h6>
            <div className='d-flex align-items-start gap-3 justify-content-between'>
              <div className='flex-1'>
                {
                  getContactValue('instagram') != '' &&
                  <div className='d-flex align-items-center justify-content-between mt-2'>
                    <div className='d-flex align-items-center gap-2'>
                      <div className='footer-icon'>
                        <img src={imgBaseUrl + getContactImage('instagram')} alt="" width={16} />
                      </div>
                      <h6 className='font-bold text-xs mb-0'>اینستاگرام:</h6>
                    </div>
                    <a href={`https://instagram.com/${getContactValue("instagram")}`} target='_blank'>
                      <h6 className='text-[#00A14B] text-xs'>{getContactValue('instagram')}</h6>
                    </a>
                  </div>
                }
                {
                  getContactValue('whatsapp') != '' &&
                  <div className='d-flex align-items-center justify-content-between mt-2'>
                    <div className='d-flex align-items-center gap-2'>
                      <div className='footer-icon'>
                        <img src={imgBaseUrl + getContactImage('whatsapp')} alt="" width={16} />
                      </div>
                      <h6 className='font-bold text-xs mb-0'>واتساپ:</h6>
                    </div>
                    <a href={`https://wa.me/${getContactValue("whatsapp")}`} target='_blank'>
                      <h6 className='text-[#00A14B] text-xs'>{getContactValue('whatsapp')}</h6></a>
                  </div>}
                {
                  getContactValue('linkdin') != '' &&
                  <div className='d-flex align-items-center justify-content-between mt-2'>
                    <div className='d-flex align-items-center gap-2'>
                      <div className='footer-icon'>
                        <img src={imgBaseUrl + getContactImage('linkdin')} alt="" width={16} />
                      </div>
                      <h6 className='font-bold text-xs mb-0'>لینکدین:</h6>
                    </div>
                    <a href={`https://www.linkedin.com/company/${getContactValue("linkdin")}`} target='_blank'>
                      <h6 className='text-[#00A14B] text-xs'>{getContactValue('linkdin')}</h6></a>
                  </div>}
              </div>
              <div className='flex-1'>
                {
                  getContactValue('youtube') != '' &&
                  <div className='d-flex align-items-center justify-content-between mt-2'>
                    <div className='d-flex align-items-center gap-2'>
                      <div className='footer-icon'>
                        <img src={imgBaseUrl + getContactImage('youtube')} alt="" width={16} />
                      </div>
                      <h6 className='font-bold text-xs mb-0'>یوتیوب:</h6>
                    </div>
                    <a href={`https://youtube.com/@${getContactValue("youtube")}`} target='_blank'>
                      <h6 className='text-[#00A14B] text-xs'>{getContactValue('youtube')}</h6></a>
                  </div>}
                {
                  getContactValue('aparat') != '' &&
                  <div className='d-flex align-items-center justify-content-between mt-2'>
                    <div className='d-flex align-items-center gap-2'>
                      <div className='footer-icon'>
                        <img src={imgBaseUrl + getContactImage('aparat')} alt="" width={16} />
                      </div>
                      <h6 className='font-bold text-xs mb-0'>آپارات:</h6>
                    </div>
                    <a href={`https://www.aparat.com/${getContactValue("aparat")}`} target='_blank'>
                      <h6 className='text-[#00A14B] text-xs'>{getContactValue('aparat')}</h6></a>
                  </div>}
              </div>

            </div>


          </div>
          <div className='item links mr-2'>
            <h6 className='font-bold text-base'>لینک ها مفید</h6>
            <div className='mt-2'>
              <div className='d-flex align-items-center justify-content-between gap-2'>
                <h6 className='font-bold text-xs	flex-1' onClick={() => { window.location.href = '/products' }}>محصولات</h6>
                <h6 className='font-bold text-right text-xs	flex-1 mt-2' onClick={() => { window.location.href = '/about-us' }}>درباره ما</h6>
              </div>
              <div className='d-flex align-items-center justify-content-between gap-2'>
                <h6 className='font-bold text-xs	flex-1' onClick={() => { window.location.href = '/branches' }}>شعب</h6>
                <h6 className='font-bold text-xs	flex-1 mt-2' onClick={() => { window.location.href = '/contact-us' }}>تماس با ما</h6>
              </div>
              <div className='d-flex align-items-center justify-content-between gap-2'>
                <h6 className='font-bold text-xs	flex-1' onClick={() => { window.location.href = '/shop' }}>فروشگاه</h6>
                <h6 className='font-bold text-xs	flex-1 mt-2' onClick={() => { window.location.href = '/employment' }}>استخدام و همکاری</h6>
              </div>
              <div className='d-flex align-items-center justify-content-between gap-2'>
                <h6 className='font-bold text-xs	flex-1' onClick={() => { window.location.href = '/blogs' }}>بلاگ و اخبار</h6>
              </div>
            </div>
          </div>
          {/* <div className='col-3'>

          </div> */}
        </div>
        <div className='logo-img-footer rounded-3xl'>
          <div className='img-bottom'></div>
          <div className='img-top'></div>
          <div >
            <img src={LogoGreen} alt="" width={100} />

          </div>
        </div>

      </div>

      <div className='footer mobile'>
        <div className='top-btn'>
          <div className='left-btn'></div>
          <div className='right-btn'></div>
          <div >
            <img src={ArrowTop} alt="" onClick={handleScrollToTop} style={{ cursor: 'pointer' }} />

          </div>

        </div>
        <div className='d-flex align-items-start justify-content-start mt-5 gap-2'>
          {/* <div className='img-box'> */}
          {/* </div> */}
          {/* <img width={80} src={LogoFooter} alt="" /> */}
          <div className='item p-2'>
            <h4 className='font-normal text-sm text-right'><span className='font-bold text-xl'>طبیعی باش</span>، با لذت بنوشید ...</h4>
            <p className='font-medium 	mt-2 text-justify mb-0' style={{ fontSize: '11px' }}>
              اگر به دنبال تجربه‌های متنوع و جذاب در دنیای نوشیدنی‌ها هستید، ما برای شما تنوعی از نوشیدنی‌ها و مزه‌ها فراهم کرده‌ایم. از طعم‌های فوق‌العاده قهوه‌های اسپرسو و لته‌؛ گرم و خوشمزه تا طعم‌های ترکیبی از میوه‌ها در نوشابه‌های ما، مطمئناً انتخابی برای هر سلیقه و فصلی پیدا خواهید کرد.
            </p>

          </div>


        </div>
        {/* <div className='item w-100 links p-2 d-flex align-items-center justify-content-start mt-3 gap-3' style={{ flexWrap: 'wrap' }}>
          <h6 className='font-extrabold text-xs'>لینک ها مفید</h6>

          <h6 className='font-bold  text-sm	flex-1' onClick={() => {window.location.href = '/products'}}>محصولات</h6>
          <h6 className='font-bold text-right text-sm	flex-1' onClick={() => {window.location.href = '/about-us'}}>درباره با ما</h6>
          <h6 className='font-bold text-sm	flex-1' onClick={() => {window.location.href = '/branches'}}>شعب</h6>
          <h6 className='font-bold text-sm	flex-1' onClick={() => {window.location.href = '/contact-us'}}>تماس با ما</h6>
          <h6 className='font-bold text-sm	flex-1' >فروشگاه</h6>
          <h6 className='font-bold text-sm	flex-1' onClick={() => {window.location.href = '/employment'}}>استخدام و همکاری</h6>
        </div> */}
        <div className='item w-100 links p-2 d-flex align-items-center justify-content-between mt-3 gap-3 '>
          <h5 className='font-extrabold title flex-1 text-right' style={{textAlign: 'right'}}>امور مشتریان</h5>
          {
            getContactValue('email') != '' &&
            <div className='d-flex align-items-center flex-col  mt-2 flex-1'>
              <div className='d-flex align-items-center flex-col gap-2'>
                <div className='d-flex align-items-center gap-1'>
                  <div className='footer-icon '>
                    <img src={imgBaseUrl + getContactImage('email')} alt="" width={8} />
                  </div>
                  <h6 className='font-bold text-xs mb-0'>ایمیل:</h6>
                </div>

              </div>
              <a href={`mailto:${getContactValue('answer')}`}>
                <h6 className='text-[#00A14B] text-xs'>{getContactValue('email')}</h6></a>
            </div>
          }
          {
            getContactValue('telephon') != '' &&
            <div className='d-flex align-items-center flex-col  mt-2 flex-1'>
              <div className='d-flex align-items-center flex-col gap-2'>
                <div className='d-flex align-items-center gap-1'>
                  <div className='footer-icon'>
                    <img src={imgBaseUrl + getContactImage('telephon')} alt="" width={8} />
                  </div>
                  <h6 className='font-bold text-xs mb-0'>شماره تماس:</h6>
                </div>
              </div>
              <a href={`tel:${getContactValue('telephon')}`} >
                <h6 className='text-[#00A14B] text-xs'>{getContactValue('telephon')}</h6></a>
            </div>}
          {
            getContactValue('answer') != '' &&
            <div className='d-flex align-items-center flex-col mt-2 flex-1'>
              <div className='d-flex align-items-center flex-col gap-2'>
                <div className='d-flex align-items-center gap-1'>
                  <div className='footer-icon'>
                    <img src={imgBaseUrl + getContactImage('answer')} alt="" width={8} />
                  </div>
                  <h6 className='font-bold text-xs mb-0'>زمان پاسخگویی:</h6>
                </div>
              </div>
              <h6 className='text-[#00A14B] text-xs'>{getContactValue('answer')}</h6>
            </div>}
        </div>
        <div className='d-flex align-items-center justify-content-between mt-2 w-100 mt-5'>
          <div className='item d-flex align-items-center gap-5 mt-2 p-2'>
            <h5 className='font-extrabold title mb-0'>شبکه های اجتماعی</h5>
            <div className=' d-flex align-items-center gap-2'>
              {
                getContactValue('instagram') != '' && <a href={`https://instagram.com/${getContactValue("instagram")}`} target='_blank'>
                  <div className='footer-icon'>
                    <img src={imgBaseUrl + getContactImage('instagram')} alt="" />
                  </div></a>
              }
              {
                getContactValue('whatsapp') != '' &&
                <a href={`https://wa.me/${getContactValue("whatsapp")}`} target='_blank'><div className='footer-icon'>
                  <img src={imgBaseUrl + getContactImage('whatsapp')} alt="" />
                </div></a>}
              {
                getContactValue('youtube') != '' && <a href={`https://youtube.com/@${getContactValue("youtube")}`} target='_blank'><div className='footer-icon'>
                  <img src={imgBaseUrl + getContactImage('youtube')} alt="" />
                </div></a>
              }
               {
                getContactValue('linkdin') != '' && <a href={`https://www.linkedin.com/company/@${getContactValue("linkdin")}`} target='_blank'><div className='footer-icon'>
                  <img src={imgBaseUrl + getContactImage('linkdin')} alt="" />
                </div></a>
              }
               {
                getContactValue('aparat') != '' && <a href={`https://www.aparat.com/${getContactValue("aparat")}`} target='_blank'><div className='footer-icon'>
                  <img src={imgBaseUrl + getContactImage('aparat')} alt="" />
                </div></a>
              }
            </div>
          </div>
          <div className='logo-img-footer rounded-3xl'>
            <div className='img-bottom'></div>
            <div className='img-top'></div>
            <div >
              <img src={LogoGreen} alt="" />

            </div>
          </div>
        </div>
      </div>

    </div >
  );
}

export default Footer;
